import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { titleStyle } from '../../../utils/commonCSS'
import { useNavigate } from 'react-router-dom'
import ConfigWORKerContrFields from './ConfigWORKerContrFields'

const VolunteeringDomainDialog = (props) => {

    // const navigate = useNavigate()
  return (
    <>
         <Dialog maxWidth='xs' fullWidth open = {props.dialogStatus} onClose={() => {props.updateDialogStatus(false)}}>
            <DialogTitle style={titleStyle}>
                Volunteering Domain
            </DialogTitle>
            <DialogContent>
                <ConfigWORKerContrFields contactNumber={localStorage?.getItem('contact')} portal={true}/>

            </DialogContent>
        </Dialog>
    </>
  )
}

export default VolunteeringDomainDialog
